import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import Modal from '../../../UniformComponents/Modal'
import Button from '../../../UniformComponents/Button'
import { warningsAfterPageRemove } from '../../../utils/SurveyChangeWarnings'
import SurveyUpdateWarnings from '../../SurveyUpdateWarnings'
import { trackBuilderPageMenuAction } from '../../../utils/MixpanelManager'

@observer
export default class PageDelete extends Component {
    close = () => {
        const { store } = this.props
        store.pageToDeleteId = null
        store.pageDeleteConfirm = false
    }

    removePage = () => {
        const { store } = this.props
        const { survey } = store
        const pageId = store.pageToDeleteId
        console.log(`removePage ${pageId}`)
        trackBuilderPageMenuAction(store, { action: 'delete page' })
        store.pageToDeleteId = null
        survey.removePage(store, survey.pages.find((page) => page.id === pageId))
        store.pageDeleteConfirm = false
    }

    getSkipLogicChanges = (page) => {
        const { store } = this.props
        const { survey } = store
        return (page && process.env.USE_NEW_SURVEY_WARNINGS)
            ? warningsAfterPageRemove(survey, page, store)
            : {
                isSkipLogicAffected: false,
                isInheritanceAffected: false,
            }
    }

    renderSkipLogicWarnings = (page) => {
        const warnings = this.getSkipLogicChanges(page)

        return <SurveyUpdateWarnings warnings={warnings} />
    }

    render() {
        const { store } = this.props
        const { survey, pageToDeleteId } = store
        const page = survey.pages.find((p) => p.id === pageToDeleteId)

        return (
            <Modal
                show={store.pageDeleteConfirm}
                onClose={this.close}
            >
                <div id="page-delete-modal">
                    <div className="uc-modal__header">
                        <h2>{i18n.t('gen_confirm_popup_title')}</h2>
                        <p className="uc-modal__desc">
                            {i18n.t('conf_page_del', { 1: page ? page.title : '' })}
                        </p>
                    </div>
                    {this.renderSkipLogicWarnings(page)}
                    <div className="uc-modal__button-panel">
                        <Button
                            onClick={this.removePage}
                            cssClass="error"
                            label={i18n.t('gen_yes')}
                        />
                        <Button
                            onClick={this.close}
                            cssClass="tertiary"
                            label={i18n.t('gen_no')}
                        />
                    </div>
                </div>
            </Modal>
        )
    }
}
